import { ActionContext } from 'vuex';

const modals = {
  groupAddUser: 'groupAddUser',
  groupAddExistingUser: 'groupAddExistingUser',
  groupAddNewUser: 'groupAddNewUser',
  groupDeleteUser: 'groupDeleteUser',
  groupTransferUser: 'groupTransferUser',
  groupChangesSummary: 'groupChangesSummary',
} as const;

type TActiveModal = keyof typeof modals | null;

interface IModalState {
  activeModal: TActiveModal | null
}

export default {
  namespaced: true,
  state: {
    activeModal: null,
  } as IModalState,

  getters: {
    activeModal: (state: IModalState): TActiveModal => state.activeModal,
    modals: () => modals,
  },

  mutations: {
    set(state: IModalState, activeModal: TActiveModal) {
      state.activeModal = activeModal;
    },
  },

  actions: {
    setActiveModal(ctx: ActionContext<IModalState, any>, activeModal: TActiveModal) {
      ctx.commit('set', activeModal);
    },
  },
};
